var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav fixed"},[_c('v-container',[_c('nav',[_c('v-row',{staticClass:"items-center align-center pdr-1",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"d-flex items-center",on:{"click":_vm.goIndex}},[_c('img',{attrs:{"height":"48px","src":_vm.logo}})])])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }